(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // Requires a network
    //

  function pxSitePrinters(
    PrinterListPOSTPaging, PrinterListService, $location, $window, $rootScope, $timeout,
    EventHandlerService, EventServiceEvents, PrinterModel, NetworkModel, $ngBootbox,
    $filter, toastr
  ) {
    return {
      restrict: 'EA',
      scope: {
        network: '=network',
        meta: '=meta',
        callback: '&callback',
        me: '=me',
        tenant: '=tenant',
        enums: '=enums',
        isThisSiteMine: '=isThisSiteMine'
      },
      templateUrl: 'app/components/sites/site/sitePrinters/sitePrinters.template.html',
      link: function(scope) {

        scope.network.loading = true;
        var scrollEnd = null;
        var containerHeight = null;
        scope.printerPagingObject = new PrinterListPOSTPaging();
        scope.networkId = scope.network._links.self.href.split('networks/')[1];
        scope.showPrinterWithIssues = false;
        scope.auxiliaries = {
          tenant: scope.tenant,
          me: scope.me,
          enums: scope.enums,
          network: new NetworkModel(scope.network),
        };


        (function() {
          setListeners();
          getNetworkPrinters();
        })();

        function getNetworkPrinters () {
          scope.printerPagingObject.pagingCriteria.networks = scope.network._links.self.href;
          scope.printerPagingObject.pagingCriteria.types = 'NETWORK,VIRTUAL';
          scope.printerPagingObject.pagingCriteria.pageSize = 10;
          scope.printerPagingObject.pagingCriteria.page = 0;
          scope.network.loading = true;
          scope.network.loadedPrinters = [];
          PrinterListService.getPrinterListPaged(scope.printerPagingObject).then(function(printers) {
            window.scrollTo(0,0);
            scope.totalPages = printers.page.totalPages;
            if (printers.list) {
              var tempPrinters = createTargetUrl(printers.list);
              tempPrinters = addIcon(tempPrinters);
              scope.network.loadedPrinters = tempPrinters;
            } else {
              scope.network.loadedPrinters = null;
            }
            scope.network.loading = false;
          }).catch(function(error){
            scope.network.loading = false;
          });
        }

        function getNextPage () {
          if (!scope.network.loading && scope.totalPages > scope.printerPagingObject.pagingCriteria.page + 1) {
            scope.network.loading = true;
            scope.printerPagingObject.pagingCriteria.page += 1;
            PrinterListService.getPrinterListPaged(scope.printerPagingObject).then(function(printers){
              if (printers.list) {
                var tempPrinters = createTargetUrl(printers.list);
                tempPrinters = addIcon(tempPrinters);
                scope.network.loadedPrinters = scope.network.loadedPrinters.concat(tempPrinters);
              }
              scope.network.loading = false;
            }).catch(function(error){});
          }
        }



        $timeout(function () {
          angular.element('#' + scope.networkId).on('scroll', function (event) {
            scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
            containerHeight = event.currentTarget.scrollHeight;

            if (!scope.network.loading && scope.totalPages > scope.printerPagingObject.pagingCriteria.page + 1) {
              if (scrollEnd > containerHeight) {
                $timeout(function() {
                  getNextPage();
                }, 300)
              }
            }
          });
        }, 100)

        scope.togglePrintersWithIssues = function () {
          scope.showPrinterWithIssues  = !scope.showPrinterWithIssues;

          if (scope.showPrinterWithIssues) {
            scope.printerPagingObject.pagingCriteria.underCreation = true;
          } else {
            scope.printerPagingObject.pagingCriteria.underCreation = false;
          }
          getNetworkPrinters();
        }

        function createTargetUrl (printers) {
          var target = $location.absUrl();
          target = target.split('sites/');
          angular.forEach(printers, function(printer) {
            printer.info.icon = 'icon-printer';
            printer.targetUrl = target[0] + 'printerProperties/' + printer.customProperties.id;
          });
          return printers;
        }

        function addIcon (printers) {
          angular.forEach(printers, function (printer) {
            printer.icon = 'icon-printer';
            printer.info.network = scope.network.name;
            printer.info.currentDate = new Date();
            printer.info.thresholdToSwitchCreatedTimeFormat = 6;

          })
          return printers;
        }

        scope.textSearch = function () {
          scope.printerPagingObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getNetworkPrinters();
          }, 500)
        }

        scope.gotoProperties = function (printer) {
          $window.open(printer.targetUrl, '_blank');
        }

        scope.gotoPropertiesQueues = function (printer) {
          $window.open(printer.targetUrl + '?printerSection=queues', '_blank');
        }

        scope.gotoPrinterIssue = function (printer) {
          var target = $location.absUrl();
          target = target.split('sites/');
          $window.open(target[0] + 'printerIssue/' + printer.customProperties.id, '_blank');
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // CONTEXT MENUS
        ////////////////////////////////////////////
        scope.openNetworkContextMenu = function (event, network) {
          scope.closeAllMenues();
          scope.clearTooltip();
          $rootScope.$broadcast('SITE_CONTEXT_CONTROL');
          $rootScope.$broadcast('SITE_NETWORK_CONTEXT_CONTROL',  scope.networkId);
          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                {title: 'NetworkName', selected: false, type: 'rename', breaker: false, order: 8, disabled: scope.me.isSystemObserver() && !scope.isThisSiteMine},
                {title: 'Settings', selected: false, type: 'networkSetting', breaker: false, order: 7},
                {title: 'Gateways', selected: false, type: 'gateways', breaker: false, warning: network.gateways.length > 0 ? false : true, order: 6},
                {title: 'TestNetwork', selected: false, type: 'testNetwork', breaker: true, order: 5},
                {title: 'Computers', selected: false, type: 'computers', breaker: true, order: 4},
                {title: 'AddPrinter', selected: false, type: 'addPrinter', breaker: false, order: 3, disabled: scope.me.isSystemObserver() && !scope.isThisSiteMine},
                {title: 'DiscoverPrinters', selected: false, type: 'discoverPrinters', breaker: true, order: 2, disabled: scope.me.isSystemObserver() && !scope.isThisSiteMine},
                {title: 'AddGatewayViaComputer', selected: false, type: 'addComputerToNetwork', breaker: false, order: 1, disabled: scope.me.isSystemObserver() && !scope.isThisSiteMine},
              ],
              context: network,
              icon: 'icon-correct-network',
              sizeClass: 'size115',
              type: 'NETWORK'
            }
            scope.menuSpecs = {
              position: {left: event.clientX, top: event.clientY},
              type: 'NETWORK'
            }
          }, 50)
        }

        scope.openPrinterContextMenu = function (event, printer, network) {
          scope.closeAllMenues();
          scope.clearTooltip();
          $rootScope.$broadcast('SITE_CONTEXT_CONTROL');
          $rootScope.$broadcast('SITE_NETWORK_CONTEXT_CONTROL', scope.networkId);

          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                {title: 'Settings', selected: false, type: 'printerSettings', breaker: false, order: 5},
                {title: 'Connection', selected: false, type: 'printerConnection', breaker: false, order: 4},
                {title: 'PrintQueues', selected: false, type: 'printerQueues', breaker: true, order: 3},
                {title: 'Status', selected: false, type: 'printerStatus', breaker: true, order: 2},
                {title: 'Delete', selected: false, type: 'deleteSite', breaker: false, order: 1, disabled: scope.me.isSystemObserver() && !scope.isThisSiteMine },
              ],
              context: printer.info,
              icon: 'icon-printer',
              sizeClass: 'size115',
              type: 'NETWORK'
            }
            scope.menuContent.additionalContent = network;
            scope.menuSpecs = {
              position: {left: event.clientX, top: event.clientY},
              type: 'NETWORK'
            }
          }, 50)
        }

        scope.closeAllMenues = function(selectedContextMenuItem, contextContentPosition, contextContent) {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem = null;
          scope.contextContentPosition = null;
          scope.contextContent = null;
          $timeout(function () {
            scope.selectedContextMenuItem = selectedContextMenuItem;
            scope.contextContentPosition = contextContentPosition;
            if (selectedContextMenuItem && selectedContextMenuItem.type === 'addGatewayToNetwork') {
              scope.contextContent = {
                context: {
                  network: new NetworkModel(contextContent.context),
                  name: 'AddGateway',
                  translate: true
                }
              }
            } else {
              scope.contextContent = contextContent;
            }
          }, 50)
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // QUICK OPEN CONTEXTUAL MENU
        ////////////////////////////////////////////
        scope.quickOpenSiteMenu = function (event, context, menuOption, additionalContent) {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem  =  null;
          scope.contextContentPosition = null;
          scope.contextContent = null;
          $rootScope.$broadcast('SITE_NETWORK_CONTEXT_CONTROL', scope.networkId);
          $timeout(function  () {
            scope.selectedContextMenuItem  =  menuOption;
            scope.contextContentPosition = { left: event.clientX, top: event.clientY, forceCenter: context.forceCenter }
            scope.contextContent = context;
            if (additionalContent) {
              scope.contextContent.additionalContent = additionalContent;
            }

          }, 50)
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'printer':
                printerTooltip(position, context);
              break;
              case 'settingTooltip':
                settingTooltip(position, context);
              break;

            }
          } else {
            scope.clearTooltip();
          }
        }

        function settingTooltip (position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            type: 'statement',
            title: title,
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20},
          }
        }

        function printerTooltip (position, printer) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Printer',
            type: 'printerDetails',
            printer: printer.info,
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20}
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }


        scope.deletePrinter = function(printer) {
          if (printer) {
            $ngBootbox.confirm($filter("stringular")($filter("translate")("DeletePrinter"), printer.info.signId)).then(function() {
              PrinterListService.deletePrinter(printer).then(function() {
                toastr.success($filter("stringular")($filter("translate")("PrinterDeleted"), printer.info.signId));
              }).catch(function(error){});
            }).catch(function(error){});
          } else {
            throw "$scope.deletePrinter: printer is missing";
          }
        };

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // UPDATING PRINTER
        ////////////////////////////////////////////
        function updatePrinter (url) {
          PrinterListService.getPrinterByURL(url).then(function(newPrinter) {
            for (var i = 0; i < scope.network.loadedPrinters.length; i++) {
              if (newPrinter.info._links.self.href === scope.network.loadedPrinters[i].info._links.self.href) {
                scope.network.loadedPrinters[i] = newPrinter;
              }
            }
          }).catch(function(error){});
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // EVENTS
        ////////////////////////////////////////////
        function setListeners () {

          $rootScope.$on('SITE_TREE_CONTEXT_CONTROL', function () {
            scope.closeAllMenues(null, null, null);
          });

          $rootScope.$on('SITE_LIST_CONTEXT_CONTROL', function () {
            scope.closeAllMenues(null, null, null);
          });

          $rootScope.$on('SITE_NETWORK_CONTEXT_CONTROL', function (name, network) {
            if (network !== scope.networkId) {
              scope.closeAllMenues(null, null, null);
            }
          });

          $rootScope.$on('SITE_NETWORK_CONTEXT_CONTROL_META', function () {
            scope.closeAllMenues(null, null, null);
          })

          // scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_CREATION_UPDATE, function(name, data) {


          // })

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_UPDATE, function(name, data) {
            // No changes in network and is network is matching -> Find and update printer on list
            if (data.network === data.oldNetwork && scope.network._links.self.href === data.network) {

              angular.forEach(scope.network.loadedPrinters, function (printer) {
                if (data.printer === printer.info._links.self.href) {
                  updatePrinter(data.printer);
                }
              })
            }

            // Changes in network and is scope.network is matching oldNetwork -> Find and remove printer from list
            if (data.network !== data.oldNetwork && scope.network._links.self.href === data.oldNetwork) {
              angular.forEach(scope.network.loadedPrinters, function (printer) {
                if (data.printer === printer.info._links.self.href) {
                  getNetworkPrinters();
                }
              })
            }

            // Changes in network and is scope.network is matching network -> Update printer list
            if (data.network !== data.oldNetwork && scope.network._links.self.href === data.network) {
              getNetworkPrinters();
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_REMOVED, function(name, data) {
            // If printer is on scope.network, and was on the list. then update the list
            if (data.network === scope.network._links.self.href) {
              angular.forEach(scope.network.loadedPrinters, function (printer) {
                if (data.printer === printer.info._links.self.href) {
                  getNetworkPrinters();
                }
              })
            }

          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_ADDED, function(name, data) {
            // If printer is added to scope.network, then update the list
            if (data.network === scope.network._links.self.href) {
              getNetworkPrinters();
            }
          });
        }


      }
    };
  }

  pxSitePrinters.$inject = [
    'PrinterListPOSTPaging', 'PrinterListService', '$location', '$window', '$rootScope', '$timeout',
    'EventHandlerService', 'EventServiceEvents', 'PrinterModel', 'NetworkModel', '$ngBootbox',
    '$filter', 'toastr'
  ];

  angular
    .module('printix-admin')
    .directive('pxSitePrinters', pxSitePrinters);

})();
